<template>
  <kst-modal-search
    :module="Model.Module"
    :moduleType="Model.ModuleType.SearchList"
    :searchData="searchData"    
    :width="1000"
    @init="handleModal_Init"
    @load="handleModal_Load"
    @reset="handleModal_Reset"
    @submit="handleModal_Submit"
  >
    <template #search="{ handleInput }">
      <Search
        :searchData="searchData"
        @input="handleInput"
      />
    </template>

    <template #search-result="{ data, userData }">
      <list
        :items="data.VendorList"
        :userData="userData"
      />
    </template>
  </kst-modal-search>
</template>

<script>
import Model from "../VenModel.js";

import Search from "./VenScLAddress_Search.vue";
import List from "./VenScLAddress_List.vue";

/**
 * flow (how to use):
 * 1. handle Init event, set and do show when needed
 * 2. handle Submit event
 */
export default {
  components: {
    Search,
    List
  },
  data: () => ({
    Model: Model,
    getListService: null,
    getVendorItemListService: null,
    searchData: {
      Search: ""
    },
    selected: null,
    // func
    hideFunc: null,
    showFunc: null
  }),
  methods: {
    /*** public method ***/

    show(getListService, getVendorItemListService) {
      this.getListService = getListService;
      this.getVendorItemListService = getVendorItemListService;
      this.showFunc();
    },

    /*** by modal ***/

    handleModal_Init(show, hide) {
      this.showFunc = show;
      this.hideFunc = hide;
      this.init_Data();

      this.$emit(this.$kst.Enum.Event.Init, this.show);
    },

    handleModal_Load(loadList) {
      const options = this.getListOptions();
      const config = this.getListService(options);
      loadList(config);
    },

    handleModal_Reset(loadList) {
      this.init_Data();
      this.handleModal_Load(loadList);
    },

    handleModal_Submit(selected, loadVendorItemList) {
      if (selected.HasItem && this.getVendorItemListService) {
        const options = this.getVendorItemListOptions(selected);
        const config = this.getVendorItemListService(options);
        this.selected = selected;
        loadVendorItemList(config, this.handleModal_Submit_Success);
      } else {
        this.$emit(this.$kst.Enum.Event.Submit, selected);
        this.hideFunc();
      }
    },
    handleModal_Submit_Success(data) {
      this.$emit(this.$kst.Enum.Event.Submit, this.selected, data);
      this.hideFunc();
    },

    /*** custom ***/

    getListOptions() {
      return {
        search: this.$kst.Out.getString(this.searchData.Search),
        field: Model.Search.SearchListAddressFields
      };
    },

    getVendorItemListOptions(vendorDetails) {
      return {
        vendor: this.$kst.Out.getInteger(vendorDetails.ID)
      };
    },

    init_Data() {
      // searchData
      this.searchData.Search = "";
    },
  }
}
</script>